module.exports = __webpack_public_path__ + "static/examp8-7f75dd26091dd6fc9c2486b9dd8bdb99.gif";